import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            username:''

        },
        username: ''
    },
    mutations: {

        setUsername(state, username) {
            state.username = username;
            state.user.username = username;
        },
        login (state, user) {
            state.user = user

            window.localStorage.setItem('user', JSON.stringify(user))
            
            if (user.username) {
                state.username = user.username;
            }
            
            console.log('Login mutation called, state.username:', state.username)
            console.log('Login mutation called, state.user:', state.user)
        }
    }
})
